import Menu from "../Menu.js";

import global from "../global.js";

// const log = global.log.getLogger("f_mtac.ui.BackgroundImageSettingsArea");

const BackgroundImageSettingsArea = function() {};

global.app.bootstrap.register_module({
    name: "ui_background_image_settings_area_menu",
    deps: ["dom_loaded"],
    init: async () => {
        Menu.create({
            name: "background_image_settings_area", 
            icon: "map", 
            contents : ["#background_image_settings"],
            open_handler : () => {},
            close_handler: () => {},
            close_timer: true
        });
    }
});

global.app.bootstrap.register_module({
    name: "ui_background_image_settings_area_tools",
    deps: ["dom_loaded", "tools"],
    init: async () => {
        let brightness_plus = global.tools.register({
            name: "brightness_plus",
            icon: "brightness_plus f_mtac-icon-xlg",
            position: "#background_image_settings",
            handler: () => {
                global.scene.map.brightness_plus();
            }
        });
        let brightness_minus = global.tools.register({
            name: "brightness_minus",
            icon: "brightness_minus f_mtac-icon-xlg",
            position: "#background_image_settings",
            handler: () => {
                global.scene.map.brightness_minus();
            }
        });
        global.tools.register({
            name: "brightness_reset",
            icon: "refresh f_mtac-icon-xlg",
            position: "#background_image_settings",
            handler: () => {
                global.scene.map.brightness_reset();
            }
        });
        global.event_bus.subscribe("scene.map.brightness",({brightness}) =>{
            if (brightness < 0.1) {
                brightness_minus.disable();
            } else {
                brightness_minus.enable();
            }
            if (brightness > 1.9) {
                brightness_plus.disable();
            } else {
                brightness_plus.enable();
            }
        });
    }
});

export default new BackgroundImageSettingsArea();

